export default __webpack_public_path__ + "static/media/about-title.800726f2.png";